import { PayloadAction, createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getStores } from "../../utilities/api-utils";

interface StoreState {
  stores: string[],
  activeStore: string,
  loading: boolean
}

const initialState: StoreState = {
  // state default values
  stores: [],
  activeStore: "",
  loading: false
};

export const fetchStores = createAsyncThunk(
  'stores/fetchStores',
  async (key: string, { signal }) => {
    const source = axios.CancelToken.source();

    signal.addEventListener('abort', () => {
      source.cancel();
    });

    const response = await getStores(key);
    return response.data;
  }
);

export const storeSlice = createSlice({
  name: 'Store',
  initialState,
  reducers: {
    // actions for setting state
    setStores: (state, action: PayloadAction<string[]>) => {
      state.stores = action.payload;
    },
    setActiveStore: (state, action: PayloadAction<string>) => {
      state.activeStore = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchStores.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchStores.fulfilled, (state, action) => {
      state.loading = false;
      for (let i = 0; i < action.payload.length; i++) {
        state.stores.push(action.payload[i].id);
      }
    });
    builder.addCase(fetchStores.rejected, (state) => {
      state.loading = false;
    });
  }
});

export const { setStores, setActiveStore } = storeSlice.actions;
export default storeSlice.reducer;
